import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthenticationGuard } from './core/security/guards/authentication-guard.service';
import { PageNotFoundComponent } from './public/pages/page-not-found.component';

const routes: Routes = [
  { path: 'print', component: PageNotFoundComponent},
  {
    path: '',
    loadChildren: 'app/master/master.module#MasterModule',
    canActivate: [AuthenticationGuard],
    canActivateChild: [],
    canLoad: [],
  },
  { path: '**', pathMatch: 'full', redirectTo: 'not-found' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }



// WEBPACK FOOTER //
// /home/runner/work/cdg-missioncontrol/cdg-missioncontrol/MissionControlClient2/MissionControl.WebUi2/mc-app/src/app/app-routing.module.ts